import React from "react"
import ProductionStepsExecutionFixedHeader from "./ProductionSteoExecutionsFixedHeader"
import ProductionStepsSupervisionHeader from "./ProductionStepsSupervisionHeader"

const ProductionStepsSupervision = ({ children, location }) => {
    const renderHeader = () => {
        const HeaderComponent = location.pathname.includes("/consultation")
            ? ProductionStepsExecutionFixedHeader
            : ProductionStepsSupervisionHeader
        return <HeaderComponent pathname={location.pathname} />
    }

    return (
        <>
            {renderHeader()}
            {children}
        </>
    )
}

export default ProductionStepsSupervision